import useSWRImmutable from "swr";
import { Identity } from 'merchant-api/types';
import { getCheckoutState } from '../getCheckoutState/getCheckoutState';
import { getIdentityQuestions } from "./getIdentityQuestions";

interface IdentityQuestionsChallengeProps {
  isLoadingIdentityChallengeQuestions: boolean;
  isErrorIdentityChallengeQuestions: any;
  identityChallengeQuestionsData?: Identity;
}

export function getIdentityChallengeQuestions(): IdentityQuestionsChallengeProps {
  const apiUrl = import.meta.env['VITE_CHECKOUT_ORCHESTRATOR_URL']
  const { checkoutData, isLoadingCheckoutState, isErrorCheckoutState } = getCheckoutState();
  const { identityData } = getIdentityQuestions();

  const { data, error, isLoading } = useSWRImmutable((checkoutData?.checkoutUuid ? `${ apiUrl }/v1/identity-verification/${ checkoutData.checkoutUuid }/challenge?idNumber=${identityData?.idNumber}`: null), { revalidateOnFocus: false });

  return {
    isLoadingIdentityChallengeQuestions: isLoading || isLoadingCheckoutState,
    isErrorIdentityChallengeQuestions: error || isErrorCheckoutState,
    identityChallengeQuestionsData: data,
  }
}
